<template>
  <div class="google-map" id="google-map" ref="googleMap"></div>
</template>

<script>
import { mapLoader } from '@/utils/googleMap'
import { cookies } from '@/utils/cookies'
import { mapState, mapMutations } from 'vuex'
const search = require('../../assets/images/location.png')

export default {
  name: 'google-map',
  props: ['name', 'inputAddress', 'inputLatitude', 'inputLongitude', 'size'],
  data: function () {
    return {
      mapName: this.name + '-map',
      marker: null,
      taxiMaker: null,
      map: null,
      geocoder: null,
      clickGeoInfo: {
        address: null,
        latitude: null,
        longitude: null,
      },
      inputLat: this.inputLatitude,
      inputLng: this.inputLongitude,
      driver_markers: [],
      MarkerClusterer: null,
      count: 1,
      markerList: [],
      drawMarkers: [],
      simplePolyline: [],
      polyline: null,
    }
  },
  mounted() {
    this.initMap()
  },
  methods: {
    ...mapMutations('googlemap', {
      vx_setGooglemapLoader: 'setGooglemapLoader',
    }),
    async initMap() {
      const lat = cookies.get('GladAddressGps').coordinates[1]
      const lng = cookies.get('GladAddressGps').coordinates[0]
      const loader = mapLoader()
      try {
        await loader.load()
        const { Map } = await google.maps.importLibrary('maps')
        const { Geocoder } = await google.maps.importLibrary('geocoding')
        this.map = new Map(this.$refs.googleMap, {
          zoom: 16,
          streetViewControl: false,
          center: new google.maps.LatLng(parseFloat(lat), parseFloat(lng)),
          gestureHandling: 'greedy', //不需按ctrl就可以縮放地圖大小
        })
        this.map.setOptions({ minZoom: 14 })
        this.geocoder = new Geocoder()
        this.addListenerInMap(this.geocoder)
        this.setDrawLineMarker()
        // 因為地圖會開關,所以需要做一個事件監聽
        this.$emit('mapReady')
      } catch (e) {
        console.error(e)
      }
    },
    moveZoom(val) {
      if (!this.map) {
        console.warn('地圖尚未初始化完成')
        return
      }
      this.map.setCenter({ lat: val.lat, lng: val.lng })
      if (val.zoom) {
        this.map.setZoom(val.zoom)
      }
    },
    loadingLoop(markerList) {
      /* console.log('loadingLoop fn', this.map.getBounds().ka) */
      this.markerList = markerList

      let filterInsideRange = this.markerList.filter((item, index, array) => {
        // console.log(item.addressGPS)
        if (item.addressGPS !== null) {
          try {
            if (
              this.map.getBounds().ka.g <= item.addressGPS.coordinates[0] &&
              item.addressGPS.coordinates[0] <= this.map.getBounds().ka.h &&
              this.map.getBounds().oa.g <= item.addressGPS.coordinates[1] &&
              item.addressGPS.coordinates[1] <= this.map.getBounds().oa.h
            ) {
              return item.addressGPS
            }
          } catch (err) {
            console.log(err.message)
            if (
              this.map.getBounds().ka.g <= item.addressGPS.coordinates[0] &&
              item.addressGPS.coordinates[0] <= this.map.getBounds().ka.h &&
              this.map.getBounds().pa.g <= item.addressGPS.coordinates[1] &&
              item.addressGPS.coordinates[1] <= this.map.getBounds().pa.h
            ) {
              return item.addressGPS
            }
          }
        }
      })
      this.setMutipleMarker(filterInsideRange)
      this.map.addListener('bounds_changed', () => {
        this.clearData()
        this.driver_markers = []
        let filterInsideRange = this.markerList.filter((item) => {
          // console.log(item.addressGPS)
          try {
            if (item.addressGPS !== null) {
              if (
                this.map.getBounds().ka.g <= item.addressGPS.coordinates[0] &&
                item.addressGPS.coordinates[0] <= this.map.getBounds().ka.h &&
                this.map.getBounds().oa.g <= item.addressGPS.coordinates[1] &&
                item.addressGPS.coordinates[1] <= this.map.getBounds().oa.h
              ) {
                return item.addressGPS
              }
            }
          } catch (err) {
            if (
              this.map.getBounds().ka.g <= item.addressGPS.coordinates[0] &&
              item.addressGPS.coordinates[0] <= this.map.getBounds().ka.h &&
              this.map.getBounds().pa.g <= item.addressGPS.coordinates[1] &&
              item.addressGPS.coordinates[1] <= this.map.getBounds().pa.h
            ) {
              return item.addressGPS
            }
          }
        })
        this.setMutipleMarker(filterInsideRange)
        // console.log(filterAgeThan5)
      })
    },
    setMutipleMarker(markerList) {
      let landMarker = null

      markerList.forEach((item, index) => {
        landMarker = new google.maps.Marker({
          position: {
            lat: item.addressGPS.coordinates[1],
            lng: item.addressGPS.coordinates[0],
          },
          label: item.name,
          map: this.map,
        })
        landMarker.addListener(
          'click',
          ((_, item) => {
            return () => {
              this.map.setCenter({
                lat: markerList[item].addressGPS.coordinates[1],
                lng: markerList[item].addressGPS.coordinates[0],
              })
              markerList[item].showCreate = true
              this.map.setZoom(this.map.getZoom())
              this.$emit('landmarkInfo', markerList[item])
            }
          })(landMarker, index),
        )
        this.driver_markers.push(landMarker)
      })
      //    this.markerCluster = new MarkerClusterer(this.map, this.driver_markers,
      //         {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'});
    },
    clearMarkerMutiple() {
      for (var i = 0; i < this.driver_markers.length; i++) {
        this.driver_markers[i].setMap(null)
      }
      this.driver_markers = []
    },
    setFouceMarker(lat, lng) {
      var myLatLng = { lat: lat, lng: lng }
      this.map.panTo(myLatLng)
    },
    addListenerInMap(geocoder) {
      // 點選map上任一個點，將會出現marker,點選下一個的時候marker將會跳到下一個
      // 這function會被不斷呼叫，因為使用者點了滑鼠
      this.map.addListener('click', (e) => {
        this.setMarker(e.latLng)
        this.setlatlng(e.latLng.lat(), e.latLng.lng())
        geocoder.geocode({ location: e.latLng }, (results, status) => {
          if (status === 'OK') {
            // console.log(results)

            this.setAddress(results[0])
            this.getData(results[0])
          } else {
            alert(
              'Geocode was not successful for the following reason: ' + status,
            )
          }
        })
      })
    },
    getData(val) {
      this.$emit('deliveryGPSData', val)
    },
    setAddress(val) {
      //  console.log(val)
      let removedAddressKey = val.formatted_address
        .trim()
        .replace(/\s/, '')
        .replace(/^\d+/, '')
      if (removedAddressKey.slice(0, 2) === '台灣') {
        removedAddressKey = removedAddressKey.slice(2, removedAddressKey.length)
      }
      // console.log(removedAddressKey)
      this.clickGeoInfo.address = removedAddressKey
      this.$emit('clickAddress', this.clickGeoInfo)
    },
    setlatlng(lat, lng) {
      // console.log("===>", lat+ lng)
      this.clickGeoInfo.latitude = lat
      this.clickGeoInfo.longitude = lng
    },
    setLatLng(lat, lng) {
      var myLatLng = { lat: lat, lng: lng }
      this.setMarker(myLatLng)
    },
    // 測試
    setDrawLineMarker() {
      this.map.addListener('click', (e) => {
        // this.setDrawMarker(e.latLng)
        this.setMarker(e.latLng)
        this.setlatlng(e.latLng.lat(), e.latLng.lng())
        this.geocoder.geocode({ location: e.latLng }, (results, status) => {
          if (status === 'OK') {
            // console.log(results)
            this.setAddress(results[0])
            this.getData(results[0])
          } else {
            alert(
              'Geocode was not successful for the following reason: ' + status,
            )
          }
        })
      })
    },
    setDrawMarker(latlng) {
      if (this.polyline !== null) {
        this.polyline.setMap(null)
      }
      if (this.drawMarkers.length === 2) {
        this.drawMarkers[0].setMap(null)
        this.drawMarkers.splice(0, 1)
        this.simplePolyline.splice(0, 1)
      }
      let drawMarker = new google.maps.Marker({
        position: latlng,
        map: this.map,
      })
      this.drawMarkers.push(drawMarker)
      this.simplePolyline.push(latlng)
      this.map.panTo(latlng)
      if (this.simplePolyline.length === 2) {
        this.polyline = new google.maps.Polyline({
          path: this.simplePolyline,
          geodesic: true,
          strokeColor: '#FF0000', // 折線顏色
          strokeOpacity: 1.0, // 折線透明度
          strokeWeight: 5, // 折線粗度
        })
        this.polyline.setMap(this.map)
      }
    },
    setMarker(latlng) {
      if (!this.map) {
        console.warn('地圖尚未初始化完成')
        return
      }
      if (this.marker === null) {
        this.marker = new google.maps.Marker({
          position: latlng,
          map: this.map,
          icon: search,
        })
        this.map.panTo(latlng)
      } else {
        this.marker.setMap(null)
        this.marker = null
        if (this.marker === null) {
          this.marker = new google.maps.Marker({
            position: latlng,
            map: this.map,
            icon: search,
          })
          this.map.panTo(latlng)
        }
      }
    },
    refreshDriverMarker() {
      if (this.driver_markers.length !== 0) {
        this.driver_markers.forEach((markers) => {
          markers.setMap(null)
        })
      }
    },
    clearData() {
      this.refreshDriverMarker()
    },
    clearSelfLandmarkData() {
      if (this.marker !== null) {
        this.marker.setMap(null)
      }
    },
  },
  computed: {
    ...mapState('googlemap', {
      vx_googlemapLoader: 'googlemapLoader',
    }),
  },
}
</script>

<style scoped>
.google-map {
  /* width: 800px;
  height: 600px; */
  margin: 0 left;
  background: gray;
}
</style>



// WEBPACK FOOTER //
// src/pages/mapComponent/LandmarkMap.vue